
export const isEmpty = params => {
  if ([undefined, null, NaN, ''].indexOf(params) > -1) return true;
  let type = window.toString.call(params);
  if (['[object Array]', '[object Object]'].indexOf(type) > -1) {
    return Object.keys(params).length === 0;
  }
};

/* istanbul ignore next */
export const on = (function () {
  if (document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
})();

/* istanbul ignore next */
export const off = (function () {
  if (document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
})();

/* istanbul ignore next */
export const once = function (el, event, fn) {
  var listener = function () {
    if (fn) {
      fn.apply(this, arguments);
    }
    off(el, event, listener);
  };
  on(el, event, listener);
};

const _userAgent = navigator.userAgent.toLowerCase();

export const isWeixin = _userAgent.indexOf('micromessenger') > -1;

export const isIOS = !!_userAgent.match(/\(i[^;]+;( u;)? cpu.+mac os x/);

export const isCommonBrowser = isWeixin === false && window.JSInterface === (window.webkit && window.webkit.messageHandlers);

export const getUrlParam = (name, str = window.location.href) => {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  let r = str.match(reg);
  if (r != null) { return unescape(r[2]); } else { return null; }
};

export const toView = (event) => {
  let $target = event.currentTarget;
  $target.scrollIntoView();
};

export const regPhone = (val) => {
  return /^1\d{10}$/.test(val);
};

export const regPsw = (val) => {
  return /.{6,20}/.test(val);
};

export const regAmount = (val) => {
  return /^\d+(\.?\d{1,2})?$/.test(val);
};

export const arrayFindIndex = function (arr, predicate, ctx) {
  if (typeof Array.prototype.findIndex === 'function') {
    return arr.findIndex(predicate, ctx);
  }

  if (typeof predicate !== 'function') {
    throw new TypeError('predicate must be a function');
  }

  var list = Object(arr);
  var len = list.length;

  if (len === 0) {
    return -1;
  }

  for (var i = 0; i < len; i++) {
    if (predicate.call(ctx, list[i], i, list)) {
      return i;
    }
  }

  return -1;
};

export const hasKeysNull = (obj) => {
  if (typeof obj !== 'object') {
    console.error('该方法仅限对象使用！');
    return;
  }
  return Object.keys(obj).filter(
    key => (['', undefined, null, NaN, 'null'].indexOf(obj[key]) > -1))
    .length > 0;
};

export const date = (date, fmt) => {
  if (!date) return '';
  if (date > 0) {
    date = Number(date);
  }
  var dateTemp = new Date(date);
  if (dateTemp.toString() === 'Invalid Date') {
    dateTemp = new Date(date.replace(/-/g, '/')) || '';
    if (dateTemp.toString() === 'Invalid Date') {
      dateTemp = new Date(date * 1000);
    }
  }
  date = dateTemp;
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'D+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  };
  if (/(Y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
    }
  }
  return fmt;
};

export const trim = (string) => {
  return string.replace(/\s/g, '');
};



// WEBPACK FOOTER //
// ./src/utils/util.js